<template lang="html">
  <section class="home" :class="$utils.slugify(title)" :id="makeId(title)">

  	<div class="container align-items-center">

      <lazy-image :src="floatImagem" :title="title" class="float-imagem" :data-name="$utils.slugify(title)" :class="posBg" />

      <article class="text" :class="alignText">
  			<div>
          <slot name="icon"></slot>
    			<h4>{{title}}</h4>
    			<slot name="text"></slot>
    			<slot name="button"></slot>
        </div>
  		</article>

  	</div>

  </section>
</template>

<script>
export default {
  name: 'HomeSection',
  props: {
    title: {
      required: true,
      type: String
    },
    alignText: {
      require: true,
      type: String
    },
    floatImagem: {
      required: true,
      type: String
    }
  },
  data () {
    return {
      posBg: (this.alignText === 'right') ? 'left' : 'right'
    }
  },
  methods: {
    makeId (str) {
      return this.$utils.slugify(str).split('-').join('_')
    }
  }
}
</script>

<style lang="scss" scoped>

section {
  overflow: hidden;
  position: relative;
}

p {
  color: $color-preto;
  margin-bottom: 40px;
}

h4 {
  margin: 20px 0 0 0;
  font-family: $proxima-nova-bold;
}

h4:after {
  content: '';
  display: block;
  width: 45px;
  height: 5px;
  background-color: $color-vermelho;
  margin: 23px 0 40px 0;
}

@media (max-width: 767px) {
  .text {
    padding: 100px 0;
  }

  .float-imagem {
    display: none;
  }
}

@media (min-width: 768px) {
  .container {
    width: 80%;
    min-height: 650px;
  }

  .text {
    max-width: 40%;
  }

  .text.left {
    padding-left: 80px;
  }

  .float-imagem.left {
    width: 50%;
  }

  .float-imagem.right {
    position: absolute;
    right: 0;
    max-width: 50%;
  }

  .site-do-evento {
    .float-imagem {
      margin-top: 70px;
      margin-right: 100px;
    }
  }

  .inscricoes {
    .float-imagem {
      bottom: 0;
    }
  }

  .credenciamento {
    .float-imagem {
      margin-top: 30px;
      margin-right: 100px;
    }
  }

  .inscricoes-em-atividades {
    .float-imagem {
      bottom: 0;
    }
  }

  .certificados {
    .float-imagem {
      margin-top: 20px;
      margin-right: 100px;
    }
  }

  .trabalhos-cientificos {
    .float-imagem {
      top: 0;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/HomeSection.vue